import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { AnimatedList, Carousel, MenuBlock, Title } from '../components';



// Add display name for better debugging
AnimatedList.displayName = 'AnimatedList';

export const Home = () => {
    const { t } = useTranslation();

    // Custom hook for animation at the top level
    const useScrollAnimation = () => {
        const [ref, inView] = useInView({
            triggerOnce: true,
            threshold: 0.1,
        });
        return { ref, inView };
    };

    const { ref: titleRef, inView: titleInView } = useScrollAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useScrollAnimation();
    const { ref: whoWeAreRef, inView: whoWeAreInView } = useScrollAnimation();
    const { ref: whyChooseUsRef, inView: whyChooseUsInView } = useScrollAnimation();
    const { ref: quoteRef, inView: quoteInView } = useScrollAnimation();

    return (
        <div className="overflow-x-hidden">
            <div className="bg-gray-100 min-h-screen">
                <div className="w-full">
                    <h1 className='hidden'>Afri-Medica Healthcare Services LLC</h1>

                    <div className='block md:hidden m'>
                        <h1 className="my-7  text-5xl font-bold text-center">
                            <Title />
                        </h1>
                    </div>

                    <Carousel />

                    <div className="bg-gray-500 p-8 mx-auto text-center">
                        <motion.div
                            ref={titleRef}
                            initial={{ opacity: 0, x: 100 }}
                            animate={{
                                opacity: titleInView ? 1 : 0,
                                x: titleInView ? 0 : 100
                            }}
                            transition={{ duration: 0.5 }}
                        >
                            <h2 className="text-4xl font-bold text-white mb-4">{t('home.title')}</h2>
                        </motion.div>

                        <motion.p
                            ref={paragraphRef}
                            initial={{ opacity: 0, x: -100 }}
                            animate={{
                                opacity: paragraphInView ? 1 : 0,
                                x: paragraphInView ? 0 : -100
                            }}
                            transition={{ duration: 0.5 }}
                            className="text-white text-1xl leading-relaxed"
                        >
                            {t('home.paragraph1')}
                        </motion.p>

                        <AnimatedList
                            ref={whoWeAreRef}
                            title={t('home.whoWeAre.title')}
                            items={t('home.whoWeAre.list', { returnObjects: true }) as string[]}
                            hasCheckmarks={false}
                            inView={whoWeAreInView}
                        />

                        <AnimatedList
                            ref={whyChooseUsRef}
                            title={t('home.whyChooseUs.title')}
                            items={t('home.whyChooseUs.reasons', { returnObjects: true }) as string[]}
                            hasCheckmarks={true}
                            inView={whyChooseUsInView}
                        />

                        <motion.p
                            ref={quoteRef}
                            initial={{ opacity: 0, x: 100 }}
                            animate={{
                                opacity: quoteInView ? 1 : 0,
                                x: quoteInView ? 0 : 100
                            }}
                            transition={{ duration: 0.5 }}
                            className='text-white text-2xl leading-relaxed mt-4'
                        >
                            {t('home.quote')}
                        </motion.p>
                    </div>

                    <div>
                        <MenuBlock />
                    </div>
                </div>
            </div>
        </div>
    );
}
